import { render, staticRenderFns } from "./UiLayoutSidebar.vue?vue&type=template&id=896d2304&scoped=true"
import script from "./UiLayoutSidebar.vue?vue&type=script&lang=js"
export * from "./UiLayoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./UiLayoutSidebar.vue?vue&type=style&index=0&id=896d2304&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896d2304",
  null
  
)

export default component.exports